import {gripMedium, gripLarge} from "@Xpresso/routes/common/components/grip";

export const viewModes = [
    {
        name: "medium",
        icon: gripMedium,
        tileWidth: 200,
    },
    {
        name: "large",
        icon: gripLarge,
        tileWidth: 260,
    },
];

